{
    "Monday": "Lunedì",
    "Mondayshort": "Lun",
    "Tuesday": "Martedì",
    "Tuesdayshort": "Mar",
    "Wednesday": "Mercoledì",
    "Wednesdayshort": "Mer",
    "Thursday": "Giovedì",
    "Thursdayshort": "Gio",
    "Friday": "Venerdì",
    "Fridayshort": "Ven",
    "Saturday": "Sabato",
    "Saturdayshort": "Sat",
    "Sunday": "Domenica",
    "Sundayshort": "Sole",
    "NAME": "DaysOfTheWeek"
}